export default "__VITE_ASSET__CJhXecMs__"